// Copyright (c) 2018 Deere & Company

export const formatShipTo = shipTo => {

    const seperator = (shipTo.name && shipTo.country) ? ', ' : '';

    return `${shipTo.name}${seperator}${shipTo.country}`;

};



// WEBPACK FOOTER //
// ./src/part-requests/shared/services/format-ship-to.js